export default __webpack_public_path__ + "3e8a9988e53acf9b9237da6158d8e177.woff2";